<template lang="pug">
  el-container(id="ClientList-container")
    el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll
      el-header(id="ClientList-header" height='40px') {{$t('Client list')}}
        el-tooltip(
          effect="light",
          :content="$t('Add new client')",
          placement="left",
          :transition='uxParam("tooltipTransition")',
          :open-delay='uxParam("tooltipActivationDelay")'
        )
          el-button.el-button--mini.float-right(
            id="ClientList-addClientButton",
            type='success',
            icon='el-icon-plus',
            :circle="uxParam('buttonCircle')",
            :round="uxParam('buttonRound')",
            :plain="uxParam('buttonPlain')",
            @click='handleAdd()'
          )
      .row.header
        .cell.client.header
          .name {{ $t('Client') }}
          el-input.input(id="ClientList-nameSearchInput" v-model='nameSearch', size='mini', type='text', clearable)
        .cell.networks.header
          .name {{ $t('Networks') }}
        .cell.password-valid.header
          .name {{ $t('Password valid days') }}
        .cell.buttons.header {{ $t('') }}
      .row(v-for="client of clients", :key='client.id', :id="'ClientList-listRow' + client.id")
        .cell.client {{ client.name}}
        .cell.networks
          .row-inner(v-for="network of client.Networks", :key='network.id')
            .network-name {{ network.name }}
        .cell.password-valid
          span {{ client.passwordValidDays > 0 ? client.passwordValidDays : '-' }}
        .cell.buttons
          el-button-group
            el-button(
              :id="'ClientList-editClient' + client.id + 'Button'",
              type="success",
              @click="handleEdit(client)",
              :title="$t('Edit client')",
              size="mini"
            )
              font-awesome-icon.float-right.button(icon="edit")
    ClientEdit(:clientId="editedClientId", :editDialogVisible="editDialogVisible", @closeEditDialog="handleCloseEditDialog()")
</template>

<script>
import ClientEdit from './ClientEdit'

export default {
  props: ['side'],
  components: { ClientEdit },
  created () {
    this.$store.dispatch('Client/getData')
  },
  data () {
    return {
      errors: {},
      editDialogVisible: false,
      editedClientId: undefined,
      nameSearch: ''
    }
  },
  methods: {
    handleAdd () {
      this.editedClientId = 0
      this.editDialogVisible = true
    },
    handleEdit (row) {
      this.editedClientId = row.id
      this.editDialogVisible = true
    },
    handleCloseEditDialog (result) {
      this.editedClientId = null
      this.editDialogVisible = false
    }
  },
  computed: {
    clients () {
      let clientsFiltered = JSON.parse(JSON.stringify(this.$store.getters['Client/listAll'])).sort((a, b) => a.name.localeCompare(b.name))
      clientsFiltered = this.nameSearch !== '' ? clientsFiltered.filter(client => client.name.toLowerCase().indexOf(this.nameSearch.toLowerCase()) > -1) : clientsFiltered
      return clientsFiltered
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.row {
  display: flex;
  font-size: $--font-size-base;
  padding: 10px 0px;
  &.header {
    color: $--color-text-secondary;
  }
  .cell {
    width: calc((100% - 55px)/2);
    border-bottom: $--border-light;
    // border: 1px dotted pink;
    &.header {
      display: flex;
      align-items: center;
      justify-content: left;
      border-bottom: 2px solid $--color-primary;
      margin-bottom: 15px;
      padding-bottom: 15px;
      .name {
        margin-right: 15px;
      }
      .input {
        max-width: 100px;
      }
    }
    &.buttons {
      text-align: right;
      width: 55px;
    }
    &.client {
      .row-inner {
        color: $--color-text-secondary;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Client/List.vue